import { useTranslation } from "react-i18next";
import { NeedStatus } from "../../autogen/bff-api";

export const useNeedStatusLabel = () => {
  const { t } = useTranslation();
  return (status: NeedStatus): string => {
    switch (status) {
      case NeedStatus.Draft:
        return t("Draft");
      case NeedStatus.Reported:
        return t("Reported");
      case NeedStatus.Approved:
        return t("Approved");
      case NeedStatus.FrameworkRecommended:
        return t("Framework recommended");
      case NeedStatus.ProcurementCreated:
        return t("Procurement created");
      case NeedStatus.UnderProcurement:
        return t("Under procurement");
      case NeedStatus.UnderCallOff:
        return t("Under call-off");
      case NeedStatus.Completed:
        return t("Completed");
      case NeedStatus.Rejected:
        return t("Rejected");
      case NeedStatus.Withdrawn:
        return t("Withdrawn");
    }
  };
};

/** Status options available in the list filter (DRAFT excluded — drafts aren't returned by the list endpoint). */
export const NEED_STATUS_FILTER_OPTIONS: NeedStatus[] = [
  NeedStatus.Reported,
  NeedStatus.Approved,
  NeedStatus.FrameworkRecommended,
  NeedStatus.ProcurementCreated,
  NeedStatus.UnderProcurement,
  NeedStatus.UnderCallOff,
  NeedStatus.Completed,
  NeedStatus.Rejected,
  NeedStatus.Withdrawn,
];
